module.exports = __webpack_public_path__ + "static/img/example.67fe6d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/example.jpg
// module id = 4h1C
// module chunks = 1